import { singleItemWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Activation, Secret } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { get: getSecret } = singleItemWrapper<Secret>(apiClient, {
      path: `/api/v${version}/code/secret`
    })

    return {
      getSecret,

      activateCode: (body: { code: string }) =>
        apiClient.post<Activation>(`/api/v${version}/code/activation`, { body })
    }
  }
} satisfies Starter
